import script from "./PageHeroContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeroContent.vue?vue&type=script&setup=true&lang=js"

import "./PageHeroContent.vue?vue&type=style&index=0&id=cc1d7bc8&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc1d7bc8"]])

export default __exports__